import { styled } from '@mui/material/styles';
import { Box, Menu, Typography } from '@mui/material';

export const SwitcherContainer = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  margin: '7px 0 0 35px',
}));

export const SwitcherText = styled(Typography)(({ theme }) => ({
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'center',
  gap: '4px',
  userSelect: 'none',
  '&:hover': {
    opacity: 0.7,
  },
  color: theme.palette.blue[400],
}));

export const StyledSwitchMenu = styled(Menu)(() => ({
  '.MuiPaper-root': {
    marginTop: '16px',
    minWidth: '200px',
  },
}));

export const FiltersGroup = styled(Box)({
  display: 'inline-flex',
  alignItems: 'flex-end',
  flexShrink: 0,
  alignSelf: 'center',
  gap: 8,
});

/* Restore when Performance Review Flow should be visible again:
export const PerfReviewFlowSlot = styled(Box)({
  display: 'inline-flex',
  alignItems: 'center',
  marginBottom: 4,
});
*/

export const CreateScorecardSlot = styled(Box)({
  display: 'inline-flex',
  alignItems: 'center',
});
